<template lang="pug">
  .field.is-grouped.is-grouped-multiline
    .control(v-for="consumable in consumables" :key="consumable.product")
      .tags.has-addons
        span.tag.is-warning
          product-name-view(:value="consumable.product" style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;")
        span.tag.is-light.has-text-weight-semibold
          span {{consumable.qty}}  
          ProductUnitLabel(:product="consumable.product")
    .control(v-for="consumable in addons" :key="consumable.product")
      .tags.has-addons
        span.tag.is-info
          product-name-view(:value="consumable.product" style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;")
        span.tag.is-light.has-text-weight-semibold
          span {{consumable.qty}}  
          ProductUnitLabel(:product="consumable.product")
    


 
</template>
<script>
import {mapState} from 'vuex'

import PRODUCT_TYPES from '../../../constants/productTypes'
import ProductUnitLabel from '../inventory/ProductUnitLabel'

export default {
  name: 'ConsumablesList',
  components: {
    ProductUnitLabel
  },
  props: {
    value: {type: Array, default: () => []}
  },

  computed: {
    ...mapState('inventory', ['productsMap']),
    consumables() {
      return this.value.filter(v => {
        const product = this.productsMap[v.product]
        if (!product) {
          return false
        }
        return product.type === PRODUCT_TYPES.CONSUMABLES && !product.isAddon
      })
    },
    addons() {
      return this.value.filter(v => {
        const product = this.productsMap[v.product]
        if (!product) {
          return false
        }
        return product.type === PRODUCT_TYPES.RETAIL || product.isAddon
      })
    }
  }
}
</script>
